import { useEffect, useContext } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

// Restore usePrompt for BrowserRouter navigation blocking
function usePrompt(when, onNavigate) {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  useEffect(() => {
    if (!when) return;
    const push = navigator.push;
    const block = navigator.block;
    let unblock = null;
    if (block) {
      unblock = block((tx) => {
        onNavigate(tx);
      });
    } else if (push) {
      navigator.push = (...args) => {
        onNavigate({ action: "PUSH", args });
      };
    }
    return () => {
      if (unblock) unblock();
      if (push) navigator.push = push;
    };
  }, [when, onNavigate, navigator]);
}

export default usePrompt;
